import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Record } from 'pkg/api/models/record';

export enum OnboardingStatus {
	OnboardingStatusUnknown = 'unknown',
	OnboardingStatusPrepared = 'prepared',
	OnboardingStatusApproved = 'approved',
	OnboardingStatusPending = 'pending',
	OnboardingStatusInvalid = 'invalid',
	OnboardingStatusRejected = 'rejected',
}

export interface GroupPaymentConfig extends Record, AllowedActionable {
	groupId: number;
	onboardingStatus: OnboardingStatus;
	active: boolean;
	paymentProvider: models.group.PaymentProvider;
	paymentProviderId: string;
	currency: string;
	serviceFeePercent: number;
	serviceFeeFixedAmount: number;
	addressCountry?: string;
}
